import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import EditIcon from '@material-ui/icons/Edit'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import { Add, Sort, Delete, Search } from '@material-ui/icons'
const styles = theme => ({
  root: {
    paddingRight: 2
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.light,
          backgroundColor: theme.palette.secondary.light
        }
      : {
          color: theme.palette.secondary.dark,
          backgroundColor: theme.palette.secondary.dark
        },
  spacer: {
    flex: '1 1 100%'
  },
  addButton: {
    marginRight: theme.spacing.unit * 2
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary
  },
  title: {
    flex: '0 0 auto'
  }
})

let AdminTableActionToolbarComponent = props => {
  const {
    readOnly,
    numSelected,
    classes,
    title,
    addButtonAction,
    editButtonAction,
    reOrderAction,
    deleteButtonAction,
    onSearch
  } = props
  if (readOnly) {
    return (
      <Toolbar className={classNames(classes.root)}>
        {onSearch && (
          <TextField
            label="Recherche"
            onChange={props.onSearch}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search color="primary" />
                </InputAdornment>
              )
            }}
          />
        )}
        {!onSearch && title && <Typography variant="title">{title}</Typography>}
      </Toolbar>
    )
  }
  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0
      })}>
      <div className={classes.title}>
        {onSearch &&
          numSelected === 0 && (
            <TextField
              label="Recherche"
              onChange={props.onSearch}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search color="primary" />
                  </InputAdornment>
                )
              }}
            />
          )}
        {numSelected > 0 && (
          <Typography variant="subheading">
            {numSelected > 1
              ? ` ${numSelected} élements sélectionnés`
              : ` ${numSelected} élement sélectionné`}
          </Typography>
        )}
        {!onSearch &&
          numSelected === 0 &&
          title && <Typography variant="title">{title}</Typography>}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {reOrderAction ? (
          <Tooltip title="Changer l'ordre d'affichage">
            <Button
              className={classes.addButton}
              onClick={reOrderAction}
              variant="fab"
              mini
              color="primary"
              aria-label="add">
              <Sort color="inherit" />
            </Button>
          </Tooltip>
        ) : null}

        {numSelected > 0 ? (
          <div className={classes.actions}>
            {deleteButtonAction ? (
              <Tooltip title="Suppression">
                <Button
                  className={classes.addButton}
                  onClick={deleteButtonAction}
                  variant="fab"
                  mini
                  color="default"
                  aria-label="edit">
                  <Delete color="inherit" />
                </Button>
              </Tooltip>
            ) : null}
            {numSelected === 1 ? (
              <Tooltip title={'Editer ' + title}>
                <Button
                  className={classes.addButton}
                  onClick={editButtonAction}
                  variant="fab"
                  color="primary"
                  aria-label="edit">
                  <EditIcon color="inherit" />
                </Button>
              </Tooltip>
            ) : null}
          </div>
        ) : (
          <Tooltip title={'Ajouter ' + title}>
            <Button
              className={classes.addButton}
              onClick={addButtonAction}
              variant="fab"
              color="secondary"
              aria-label="add">
              <Add color="inherit" />
            </Button>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  )
}

AdminTableActionToolbarComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  addButtonAction: PropTypes.func,
  editButtonAction: PropTypes.func,
  reOrderAction: PropTypes.func,
  deleteButtonAction: PropTypes.func,
  readOnly: PropTypes.bool,
  onSearch: PropTypes.func
}

export default withStyles(styles)(AdminTableActionToolbarComponent)



// WEBPACK FOOTER //
// ./src/routes/Admin/components/CommonComponents/AdminTableActionToolbarComponent.js